var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-5",attrs:{"fluid":""}},[_c('div',[_c('h3',{staticClass:"text-info"},[_vm._v("مصرفنا")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.about)}})]),_c('div',[_c('h3',{staticClass:"text-info mt-5"},[_vm._v("الشروط والأحكام")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.conditions)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }